import { useT } from '@powerportalspro/react';
import { Section, SectionColumn } from '@powerportalspro/react-fluent';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Layout.Section.SectionMainDemo';

export function SectionMainSample() {
  const t = useT();
  return (
    <Section columnMinWidth="200px">
      <SectionColumn>{t(`${STRINGS_BASE}.column1-label`)}</SectionColumn>
      <SectionColumn>{t(`${STRINGS_BASE}.column2-label`)}</SectionColumn>
      <SectionColumn>{t(`${STRINGS_BASE}.column3-label`)}</SectionColumn>
      <SectionColumn>{t(`${STRINGS_BASE}.column4-label`)}</SectionColumn>
    </Section>
  );
}
